import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  clearErrorsFromServer as clearErrorsFromServerAction,
  loadCompanyRequests as loadCompanyRequestsAction,
  setMergeCompanyRequestModalVisibility as setMergeCompanyRequestModalVisibilityAction,
  setMergedSuccessModalVisibility as setMergedSuccessModalVisibilityAction,
} from '../../slices/company_request_slice'
import { loadCompanies as loadCompaniesAction } from '../../slices/company_slice'
import CompanyFormModal from '../modals/CompanyFormModal'
import MergeCompanyModalContent from './MergeCompanyModalContent'
import SuccessModalContent from './SuccessModalContent'

export function MergeCompany() {
  const { mergeCompanyRequestModalVisibility, mergedSuccessModalVisibility, currentRequest } = useSelector(
    (state) => state.companyRequest
  )

  const dispatch = useDispatch()

  const onCloseMergeCompanyModal = () => {
    dispatch(clearErrorsFromServerAction('merge'))
    dispatch(setMergeCompanyRequestModalVisibilityAction(false))
  }

  const onCloseMergedSuccessModal = () => {
    dispatch(loadCompaniesAction())
    dispatch(loadCompanyRequestsAction())
    dispatch(setMergedSuccessModalVisibilityAction(false))
  }

  return (
    <>
      <CompanyFormModal open={mergeCompanyRequestModalVisibility}>
        <MergeCompanyModalContent request={currentRequest} onBack={onCloseMergeCompanyModal} />
      </CompanyFormModal>
      <CompanyFormModal open={mergedSuccessModalVisibility}>
        <SuccessModalContent title={'merge successful'} onNext={onCloseMergedSuccessModal} />
      </CompanyFormModal>
    </>
  )
}
